  <template>
  <div>
  <b-modal style="padding:15px" size="lg" id="AddInvoiceModal" ref="modal" title="Add Invoice" ok-title="Submit" cancel-title="Close" 
      @show= "resetModal()" @hidden= "resetModal()" @ok= "handleOk" :ok-disabled = "this.$refs.AddInvoiceForm != undefined ? !this.$refs.AddInvoiceForm.checkValidity() : true">
        <form ref="AddInvoiceForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <b-form-group label="Client" label-for="Client" autocomplete="off">
                  <b-form-select v-model= "SelectedClientId" :options="Clients" value-field="id" text-field="companyName">
                      <b-form-select-option :value = 0 disabled hidden>Select Client</b-form-select-option>
                  </b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <!--NAME INPUT-->
               <b-form-group  label="Description" label-for="Description" autocomplete="off">
                <b-form-input id="Description" v-model= "Description" type = "text"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
               <b-form-group  label="Amount Debited" label-for="AmountDebited" autocomplete="off">
                <b-form-input id="AmountDebited" v-model= "AmountDebited" type = "text"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group  label="Amount Credited" label-for="AmountCredited" autocomplete="off">
                <b-form-input id="AmountCredited" v-model= "AmountCredited" type = "text" required></b-form-input>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      <Toaster ref ="toaster"/>
    </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'AddInvoice',
    data(){
        return{
          moduleName:'Add Invoice',
          Description:null,
          AmountCredited:0,
          AmountDebited:0, 
          SelectedClientId:0,
          Clients:[]    
		}
  },
components:{
Toaster
},
created()
{
  let model = {
            "CompanyId":this.$auth.user().companyId,
          }
          axios.post('/client/getall', model)
          .then(res=>{
          
            this.Clients = res.data.data
          });
},

methods:{

    AddInvoice(){ 
     
     axios.post('/clientledger/Add', 
      {"Description":this.Description,"AmountCredited":parseFloat(this.AmountCredited), "AmountDebited":parseFloat(this.AmountDebited),
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id,"ClientId":this.SelectedClientId
      
      })
      .then(res=>{
        console.log(res)
            if(res.data.status == 1)
            {
               
                this.$refs.toaster.showToast('Sucess','success','Invoice has been added successfully')
                 this.$bvModal.hide('AddInvoiceModal')
                 this.$parent.getInvoices();      
            }
             else if(res.data.status == -1)
            {
                 this.$refs.toaster.showToast('Error','danger',res.data.msg)
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.AddInvoiceForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.SelectedClientId = 0;
        this.AmountCredited = 0;
        this.AmountDebited = 0; 
        this.Description = null;
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.AddInvoice()
        
       
      },
 
  
  },
	

}
</script>
